<template>
    <div :key="$store.getters['resource/currentResource'].key">

        <help :text="$t('help.conversions')" :title="$t('help.conversion_title')"/>

        <ContentConversionFilters
                :tableLoading="loading"
                :filters="filters"
        >
        </ContentConversionFilters>
        <div class="position-relative">
            <loader v-if="loading" />

            <v-server-table
                    ref="appTable"
                    name="contentConversionTableTotal"
                    class="white-container content-conversion-table-total"
                    url="/admin/content/analytics/total"
                    :columns="columns.total"
                    :options="optionsTotal"
                    @loaded="loading = false"
                    @loading="loading = true"
            >
                <template slot="content_total" slot-scope="props">
                    <span>{{ props.row.content_total }} {{$t('conversion.content_items')}}</span>
                </template>
                <template slot="granted_percent_total" slot-scope="props">
                    <span>{{ floatToPercent(props.row.granted_percent) }}% / {{ props.row.granted_total }}</span>
                </template>
                <template slot="paywalled_percent_total" slot-scope="props">
                    <span>{{ floatToPercent(props.row.paywall_percent) }}% / {{ props.row.paywall_total }}</span>
                </template>
                <template slot="signups_percent_total" slot-scope="props">
                    <span>{{ floatToPercent(props.row.signups_percent) }}% / {{ props.row.signups_total }}</span>
                </template>
                <template slot="conversions_percent_total" slot-scope="props">
                    <span>{{ floatToPercent(props.row.conversions_percent) }}% / {{props.row.conversions_total}}</span>
                </template>
                <template slot="mrr_per_view_total" slot-scope="props">
                    <span>{{getCurrencySign(currency)}}{{ floatDecimalNormalize(formatToDollars(props.row.mrr_per_view_total), 3) }}</span>
                </template>
                <template slot="mrr_per_paywall_total" slot-scope="props">
                    <span>{{getCurrencySign(currency)}}{{ floatDecimalNormalize(formatToDollars(props.row.mrr_per_paywall_total), 3) }}</span>
                </template>
            </v-server-table>

            <v-server-table
                    ref="appTable"
                    name="contentConversionTable"
                    class="white-container content-conversion-table"
                    url="/admin/content/analytics"
                    :columns="columns.content"
                    :options="options"
                    @loaded="loading = false"
                    @loading="loading = true"
            >

                <template slot="beforeFilter">
                    <i style="font-size: larger" class="icon-order mr-sm-1" />
                    {{ $t('global.ordered_by') }}
                    <ContentConversionSorting
                            :tableLoading="loading"
                            :sorts="sorts"
                            class="content-data-sorting"
                    ></ContentConversionSorting>
                    <!--</b-row>-->
                </template>
                <template slot="beforeLimit" v-if="totalRecordsCount > 10">
                    {{ $t('global.showing') }}<span style="display: inline-block;width: 10px;"></span>
                </template>
                <template slot="afterLimit" v-if="totalRecordsCount > 10">
                    &nbsp;{{ $t('global.of_records_found', { number: totalRecordsCount }) }}
                </template>
                <template slot="content_data" slot-scope="props">
                    <div v-if="props.row.content.title">
                        <span style="font-weight: bold;" v-html="props.row.content.title"></span>
                    </div>
                    <div v-if="props.row.content.date">
                        <span>Date/Time UTC: {{ props.row.content.date }}</span>
                    </div>
                    <div v-if="props.row.content.link">
                        <span>URL: </span>
                        <a v-if="props.row.content.link" :title="props.row.content.link" :href="props.row.content.link"
                           target="_blank">{{props.row.content.link}}</a>
                    </div>
                    <div class="content-conversion-categories" v-if="props.row.content.categories.length"  >
                        <span>Categories: </span>

                        <span v-for="(category, index) in props.row.content.categories"
                        >
                            <span v-if="index != 0">, </span><span v-html="category.title"></span>
                        </span>
                    </div>
                    <div class="content-conversion-categories" v-if="props.row.content.authors.length"  >
                        <span>Authors: </span>

                        <span v-for="(author, index) in props.row.content.authors"
                        >
                            <span v-if="index != 0">, </span><span v-html="author.title"></span>
                        </span>
                    </div>
                </template>


                <template slot="granted_percent_total" slot-scope="props">
                    <span>{{ floatToPercent(props.row.granted_percent) }}% / {{ props.row.granted_total }}</span>
                </template>
                <template slot="paywalled_percent_total" slot-scope="props">
                    <span>{{ floatToPercent(props.row.paywalled_percent) }}% / {{ props.row.paywalled_total }}</span>
                </template>
                <template slot="signups_percent_total" slot-scope="props">
                    <span>{{ floatToPercent(props.row.signups_percent) }}% / {{ props.row.count_signups }}</span>
                </template>
                <template slot="conversions_percent_total" slot-scope="props">
                    <span>{{ floatToPercent(props.row.conversions_percent) }}% / {{props.row.count_conversions}}</span>
                </template>
                <template slot="mrr_per_view_total" slot-scope="props">
                    <span>{{getCurrencySign(currency)}}{{ floatDecimalNormalize(formatToDollars(props.row.mrr_per_view), 3) }}</span>
                </template>
                <template slot="mrr_per_paywall_total" slot-scope="props">
                    <span>{{getCurrencySign(currency)}}{{ floatDecimalNormalize(formatToDollars(props.row.mrr_per_paywall), 3) }}</span>
                </template>
            </v-server-table>
        </div>
    </div>
</template>

<script>
    import axios from '@/utils/axios';
    import { Event } from 'vue-tables-2';
    import ContentConversionFilters from '@/components/contentConversion/ContentConversionFilters';
    import ContentConversionSorting from '@/components/contentConversion/ContentConversionSorting';
    import contentFilters from './contentConversionFilters.js';
    import contentSorts from './contentConversionSorting.js';
    import filters from '@/components/global/filters';
    import i18n from '@/utils/i18n';
    import { assign } from 'lodash';

    export default {
        middleware: 'auth',
        name: 'ContentConversion',
        components: {
            ContentConversionFilters,
            ContentConversionSorting,
            filters,
        },
        data: () => {
            return {
                loading: false,
                totalRecordsCount: null,
                params: {},
                currency: '',
                columns: {
                    total: [
                        'content_total',
                        'views_total',
                        'unique_total',
                        'granted_percent_total',
                        'paywalled_percent_total',
                        'signups_percent_total',
                        'conversions_percent_total',
                        'mrr_per_view_total',
                        'mrr_per_paywall_total',
                    ],
                    content: [
                        'content_data',
                        'views_total',
                        'views_unique_total',
                        'granted_percent_total',
                        'paywalled_percent_total',
                        'signups_percent_total',
                        'conversions_percent_total',
                        'mrr_per_view_total',
                        'mrr_per_paywall_total',
                    ],
                },
                filters: contentFilters,
                sorts: contentSorts,
                filterObject: {},
                extended: false,
                options: {
                    skin: [],
                    headings: {
                        content_data: i18n.t('conversion.content_data'),
                        views_total: i18n.t('conversion.views'),
                        views_unique_total: i18n.t('conversion.unique'),
                        granted_percent_total: i18n.t('conversion.granted'),
                        paywalled_percent_total: i18n.t('conversion.paywalled'),
                        signups_percent_total: i18n.t('conversion.signups'),
                        conversions_percent_total: i18n.t('conversion.conversions'),
                        mrr_per_paywall_total: i18n.t('conversion.mrr_per_paywall'),
                        mrr_per_view_total: i18n.t('conversion.mrr_per_view'),
                    },
                    dateColumns: ['created_at'],
                    sortable: [],
                    clientMultiSorting: false,
                    customFilters: ['custom', 'sorting'],
                    perPage:
                        !!localStorage.getItem('perPage') && localStorage.getItem('perPage') !== ''
                            ? localStorage.getItem('perPage')
                            : 10,
                    filterable: false,
                    requestFunction: function (data) {
                        let params = {};
                        params.limit = data.limit;
                        params.filter = data.custom;
                        params.page = data.page;
                        if (data.sorting) {
                            params = assign(params, data.sorting);
                        }
                        else
                        {
                            params.order = 'total_views';
                            params.sort = 'desc';
                        }

                        localStorage.setItem('perPage', data.limit);
                        if (!params.filter) {
                            params.filter = {};
                        }
                        return axios
                            .get(this.url, {
                                params: params,
                            })
                            .catch((e) => {
                                this.dispatch('error', e);
                            });
                    },
                    responseAdapter: function (resp) {
                        let data = this.getResponseData(resp);
                        return {
                            data: data.data.items,
                            count: data.data.paginator.total_items,
                        };
                    },
                },
                optionsTotal: {
                    skin: [],
                    headings: {
                        content_total: i18n.t('conversion.content_total'),
                        views_total: i18n.t('conversion.views'),
                        unique_total: i18n.t('conversion.unique'),
                        granted_percent_total: i18n.t('conversion.granted'),
                        paywalled_percent_total: i18n.t('conversion.paywalled'),
                        signups_percent_total: i18n.t('conversion.signups'),
                        conversions_percent_total: i18n.t('conversion.conversions'),
                        mrr_per_paywall_total: i18n.t('conversion.mrr_per_paywall'),
                        mrr_per_view_total: i18n.t('conversion.mrr_per_view'),
                    },
                    dateColumns: ['created_at'],
                    sortable: [],
                    clientMultiSorting: false,
                    customFilters: ['custom'],
                    perPage:
                        !!localStorage.getItem('perPage') && localStorage.getItem('perPage') !== ''
                            ? localStorage.getItem('perPage')
                            : 10,
                    filterable: false,
                    requestFunction: function (data) {
                        let params = {};
                        params.filter = data.custom;
                        if (!params.filter) {
                            params.filter = {};
                        }

                        return axios
                            .get(this.url, {
                                params: params,
                            })
                            .catch((e) => {
                                this.dispatch('error', e);
                            });
                    },
                    responseAdapter: function (resp) {
                        let data = this.getResponseData(resp);
                        return {
                            data: data.data.items,
                            count: 1,
                        };
                    },
                },
            };
        },
        mounted() {
            this.getSettings();
            Event.$on('vue-tables.contentConversionTable.loaded', ({ data }) => {
                this.totalRecordsCount = data.paginator.total_items;
            });
        },
        methods: {
            getSettings() {
                this.getData(`resources/dashboard/settings`)
                    .then(response => {
                        if(_.has(response.data.default_configs, 'default_stats_currency')) {
                            this.currency = response.data.default_configs.default_stats_currency.toUpperCase();
                        }
                        else {
                            this.currency = 'USD';
                        }
                    })
                    .catch(error => {
                        console.log('get settings error', error)
                    })
                    .finally(() => {
                    })
            }
        },
        destroyed() {
            Event.$off('vue-tables.contentConversionTable.loaded');
        },
    };
</script>
<style lang="scss" scoped>
    .icon-order {
        display: block;
    }
</style>